import { Stack, Typography } from '@mui/material'
import { useEntitiesFromSearch } from 'api/search'
import { useProducts } from 'api/aws/useProducts'
import CustomProductsAutocomplete from 'components/CustomProductsAutocomplete/CustomProductsAutocomplete'
import { archivedServiceKeys, existingServiceKeys, toServiceKey } from 'components/DataGrid/operators/formatKeys'
import React from 'react'
import { CustomProductDraft, Product } from 'types'
import ProductDraftList from '../ProductRows/ProductDraftList'

const SelectMargins = ({
  drafts,
  onAddDraft,
  onEditDraft,
  onRemoveDraft,
  selectedProduct,
  selectCustomProduct,
}: {
  drafts: CustomProductDraft[]
  onAddDraft: (p: Product) => void
  onEditDraft: (id: string, patch: Partial<CustomProductDraft>) => void
  onRemoveDraft: (id: string) => void
  selectedProduct: Product
  selectCustomProduct: (newValue: Product) => void
}) => {
  const { custom_products } = useEntitiesFromSearch()
  React.useEffect(() => console.log('custom_products', custom_products), [custom_products])
  const { data: products } = useProducts(true)
  const selectedServiceKeys = React.useMemo(() => existingServiceKeys(drafts), [drafts])
  const archivedKeys = React.useMemo(() => archivedServiceKeys(custom_products ?? []), [custom_products])

  console.log('selectedServiceKeys', selectedServiceKeys)
  return (
    <Stack sx={{ width: '100%' }}>
      <Typography>Custom Service Selection</Typography>
      <CustomProductsAutocomplete
        products={products ?? []}
        value={selectedProduct}
        onChange={newValue => {
          selectCustomProduct(newValue)
          console.log('newValue', newValue)
          if (newValue) onAddDraft(newValue)
        }}
        label="Select Service"
        error={false}
        isLoading={false}
        disabled={false}
        sx={{ minWidth: '100%' }}
        getOptionDisabled={option => {
          const key = toServiceKey(option)
          return selectedServiceKeys.has(key)
        }}
        getOptionArchived={option => {
          const key = toServiceKey(option)
          return archivedKeys.has(key)
        }}
      />

      <ProductDraftList drafts={drafts} onEditDraft={onEditDraft} onRemoveDraft={onRemoveDraft} />
    </Stack>
  )
}

export default SelectMargins
